let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1JZIk")).then(() => parcelRequire('ly6Vc'));